var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isOptionGroup = function (option) { return 'options' in option; };
/**
 * Drops disabled options unless they're among the selected value(s), removing any group left
 * empty, so a value that can no longer be chosen still displays without being offered. Missing
 * entries in the value (a stored id with no matching option) are ignored, as react-select does.
 */
export var withoutUnselectedDisabledOptions = function (options, value) {
    if (!options) {
        return options;
    }
    var selectedValues = new Set([]
        .concat((value !== null && value !== void 0 ? value : []))
        .flatMap(function (selected) { return (selected ? [selected.value] : []); }));
    var isOffered = function (option) { return !option.disabled || selectedValues.has(option.value); };
    return options.flatMap(function (option) {
        if (!isOptionGroup(option)) {
            return isOffered(option) ? [option] : [];
        }
        var groupOptions = option.options.filter(isOffered);
        return groupOptions.length ? [__assign(__assign({}, option), { options: groupOptions })] : [];
    });
};
